import { render, staticRenderFns } from "./ContactosNotificados.vue?vue&type=template&id=5e2b5c4a&scoped=true&"
import script from "./ContactosNotificados.vue?vue&type=script&lang=ts&"
export * from "./ContactosNotificados.vue?vue&type=script&lang=ts&"
import style0 from "./ContactosNotificados.vue?vue&type=style&index=0&id=5e2b5c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b5c4a",
  null
  
)

export default component.exports